import { geojsonToArcGIS } from "@terraformer/arcgis"

import { subclass, property } from "@arcgis/core/core/accessorSupport/decorators";
import Widget from "@arcgis/core/widgets/Widget";
import { tsx } from "@arcgis/core/widgets/support/widget";

import FeatureLayer from '@arcgis/core/layers/FeatureLayer'
import FeatureSet from "@arcgis/core/rest/support/FeatureSet";

import Graphic from "@arcgis/core/Graphic"
import * as query from "@arcgis/core/rest/query";
import Query from '@arcgis/core/rest/support/Query'

import { Layer } from './layers'
import { appConfig} from './main'
import WMSLayer from "@arcgis/core/layers/WMSLayer";

const geometryTypes = {
    Point: 'point',
    LineString: 'polyline',
    Polygon: 'polygon',
    MultiPoint: 'multipoint',
    MultiLineString: 'polyline',
    MultiPolygon: 'polygon',
}

const CSS = {
    base: "querywidget"
};

@subclass("esri.widgets.PresetPanel")
class QueryWidget extends Widget {

    @property()
    layer?: Layer

    @property()
    searchField: string = 'title'

    @property()
    queryString: string = ''

    @property()
    max: number = 20

    @property()
    clickSearchOnly: boolean = false

    @property()
    goToParams: any = {}

    @property()
    queryResults: any[] = []

    @property()
    isLoading: boolean = false

    constructor(params: any) {
        super(params);
        this.search = this.search.bind(this)
        this.goTo = this.goTo.bind(this)
        this.handleQueryResults = this.handleQueryResults.bind(this)
    }

    postInitialize() {
        
    }

    goTo(e: any) {
        const name = $(e.target).attr('name');
        if(!name) return;

        this.goToParams.target = this.queryResults[parseInt(name)]
        appConfig.activeView?.goTo(this.goToParams)
    }


    handleQueryResults(results: __esri.FeatureSet) {
        this.queryResults = results.features.slice(0, this.max)
        this.isLoading = false
    }

    handleQueryError(error: any) {
        this.isLoading = false
    }

    search(e: any) {
        if (!this.clickSearchOnly || (this.clickSearchOnly && e.target.type == 'text')) {
            if (this.layer?.layerType == "FeatureLayer") {
                let qp = (this.layer.esriLayer as FeatureLayer).createQuery();
                qp.where = `UPPER(` + this.searchField + `) LIKE '%` + ($('#searchText').val() as string).toUpperCase() + `%'`;

                (this.layer.esriLayer as FeatureLayer).queryFeatures(qp).then(this.handleQueryResults, this.handleQueryError)

            } else if(this.layer?.layerType === "WMSLayer") {

                if(this.layer.url) {
                    const params = new URLSearchParams({
                        service: 'WMS',
                        version: '1.1.1',
                        request: 'GetFeatureInfo',
                        layers: this.layer.layerId ?? '',
                        query_layers: this.layer.layerId ?? '',
                        srs: 'EPSG:4326',
                        bbox: '100,-50,160,0',
                        width: '1',
                        height: '1',
                        x: '1',
                        y: '1',
                        info_format: 'application/json',
                        exceptions: 'application/json',
                        feature_count: '500',
                        cql_filter: `strToLowerCase(${this.searchField}) like '%${($('#searchText').val() as string).toLowerCase()}%'`
                    });

    
                    fetch(`${this.layer.url}?${params.toString()}`).then((resp) => resp.json()).then(results => {
                        this.handleQueryResults(new FeatureSet({
                            features: results.features.map((f: any) => {
                                const {attributes, geometry } = geojsonToArcGIS(f) as any;
                                return new Graphic({
                                    attributes,
                                    geometry: {
                                        ...geometry,
                                        type: geometryTypes[f.geometry.type]
                                    }
                                })
                            })
                        }))
                    })
                }

            } else {
                
                let qry = new Query()
                qry.returnGeometry = true
                qry.outFields = ["*"]
                qry.where = `UPPER(` + this.searchField + `) LIKE '%` + ($('#searchText').val() as string).toUpperCase() + `%'`

                if(!this.layer?.qryUrl) return;

                query.executeQueryJSON(this.layer.qryUrl, qry).then(this.handleQueryResults, this.handleQueryError);
            }
            this.isLoading = true
        }
    }

    render() {
        let resultHTMLObjects = []
        let results: Graphic
        if (this.queryResults) {
            for (let i : number = 0; i < this.queryResults.length; i++) {
                results = this.queryResults[i]

                resultHTMLObjects.push(
                    <div class="row row-no-margin" style="margin-top: 15px" key={Math.floor(Math.random() * 1000)}>
                        <div class="col-md-12">
                            {results.attributes[this.searchField]}
                            <span name={i.toString()} style="float: right; font-size: 20px; margin-top: auto;" class="esri-icon-locate" onclick={this.goTo}></span>
                            
                        </div>
                    </div>
                )
            }
        }

        let loadingHtml = <div></div>
        
        if (this.isLoading) {
            loadingHtml = <div class="spinner-icon" style="margin: auto"></div>
        }

        return (
            <div class={this.classes(CSS.base)} key="presetpanel-container">
                <div class="row row-no-margin" key="presetpanel-options">
                    <label for="searchText">
                        Search { this.layer?.name ?? '' }: 
                        <div class="input-group">
                            <input type="text" id="searchText" oninput={this.search} class="form-control"></input>
                            <span class="input-group-btn">
                                <button class="btn btn-default" onclick={this.search} type="button">
                                    <span class="esri-icon-search"></span>&nbsp;
                                </button>
                            </span>
                        </div>
                    </label>
                </div>
                {loadingHtml }
                {resultHTMLObjects}
            </div>
        );
    }
}

export default QueryWidget